import React from 'react'

function Select({ classic = false, children, ...rest }) {

    if (classic) {
        return (
            <select
                {...rest}
                className='bg-white px-5 py-3 border border-gray-300 
                text-xs rounded-lg text-gray-400 w-full capitalize'
            >
                {children}
            </select>
        )
    }

    return (
        <select
            {...rest}
            className='bg-gray-100 px-5 py-2 border border-gray-200 text-xs rounded-md capitalize'
        >
            {children}
        </select>
    )
}

export default Select